import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./productionOrderSapFilter.data.form";
import InputSelect from "../../../utils/InputSelect";
import InputDate from "../../../utils/InputDate";
import InputText from "../../../utils/InputText";
import { POSAP_STATUS } from "../../../../constants";

const ProductionOrderSapFilterForm = (props) => {
  const { t, handleSubmit, filtered, onClean } = props;

  const loadData = async () => {
    // TODO: ??
  };

  useEffect(() => {
    loadData();
  }, []);

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="orderFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.productionOrderSap.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#orderFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  <div className="row">
                    <div className="col-3">
                      <Field
                        id="sapDateStart"
                        labelField={t(
                          "forms.productionOrderSap.labels.sapStartDate"
                        )}
                        className="form-control"
                        name="sapDateStart"
                        component={InputDate}
                        language="es"
                        dateFormat="dd/MM/yyyy"
                      />
                    </div>
                    <div className="col-3">
                      <Field
                        id="sapQuantity"
                        className="form-control"
                        labelField={t(
                          "forms.productionOrderSap.labels.sapQuantity"
                        )}
                        name="sapQuantity"
                        component={InputText}
                        fieldType="text"
                        placeholder=""
                      />
                    </div>
                    <div className="col-3">
                      <Field
                        id="idOrderSap"
                        className="form-control"
                        labelField={t(
                          "forms.productionOrderSap.labels.idOrderSap"
                        )}
                        name="idOrderSap"
                        component={InputText}
                        fieldType="text"
                        placeholder=""
                      />
                    </div>
                    <div className="col-3">
                      <Field
                        id="status"
                        name="status"
                        labelField={t("forms.productionOrderSap.labels.status")}
                        component={InputSelect}
                        optionLabel="label"
                        optionValue="code"
                        options={POSAP_STATUS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        placeholder=""
                        classNamePrefix="dark"
                        addOptionEmpty
                        classNameContainer="flex-grow-1"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProductionOrderSapFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  initialValues: PropTypes.object,
  filtered: PropTypes.bool,
  onClean: PropTypes.func,
};

const ProductionOrderSapFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "OrderFilterForm",
})(withTranslation()(ProductionOrderSapFilterForm));

export default ProductionOrderSapFilterFormF;
